import { Controller } from '@hotwired/stimulus'

export default class ChangelogToggleController extends Controller {
  toggle() {
    const { id } = this.element.dataset
    const changelogEl = document.querySelector(`.changelog[data-id='${id}']`)
    changelogEl.classList.toggle('closed')
  }
}
